<template>
  <div>
    <div
      id="frameChat"
      style="
        display: none;
        position: fixed;
        z-index: 2000;
        top: 0px;
        left: 0px;
        right: 0px;
        height: 99vh;
        background: #fff;
      "
      v-show="!show"
    >
      <iframe
        id="chatFrame"
        :src="
          '/static/html/kefu/index.html?phoneNumber=' +
          this.phoneNumber +
          '&name=' +
          this.name +
          '&UserId=' +
          this.UserId
        "
        style="height: 100%; width: 100%"
        frameborder="0"
      ></iframe>
    </div>
    <div class="loading_bg" v-if="show == true">
      <div class="loading">
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      openchat: false,
      show: true,
      phoneNumber: "",
      name: "",
      UserId: "",
    };
  },
  mounted() {
    var that = this;
    that.OpenChat();
    this.phoneNumber = this.$route.query.phoneNumber;
    this.name = this.$route.query.name;
    this.UserId = this.$route.query.UserId;
    //接收iframe发回的消息
    window.addEventListener(
      "message",
      function (e) {
        let data = e.data;
        if (data.c == "succeed") {
          that.show = false;
        }
        if (data.c == "hide") {
          hideChat();
        }
        if (data.c == "msg" && !this.openchat) {
          let t = data.t.message.value;
          // console.log(t);
        }
      },
      false
    );
  },
  methods: {
    OpenChat() {
      this.openchat = true;
      document.getElementById("frameChat").style.display = "";
      // setTimeout(function () {
      //   document
      //     .getElementById("chatFrame")
      //     .contentWindow.document.getElementById("kefu")
      //     .click();
      // }, 100);
    },
    hideChat() {
      this.openchat = false;
      document.getElementById("frameChat").style.display = "none";
    },
  },
};
</script>
<style scoped lang="scss">
/* 设置位置 */
.loading {
  position: absolute;
  z-index: 9999;
  /* 居中 */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* 高度 */
  height: 40px;
  /* 弹性布局 */
  display: flex;
  /* 设置子项在y轴方向居中，应该是设置起点在中间，非常有用，不然动画很怪 */
  align-items: center;
}

/* 小竖条 */
.item {
  height: 50px;
  width: 5px;
  background: #0099cc;
  /* 加margin，使竖条之间有空隙 */
  margin: 0px 3px;
  /* 圆角 */
  border-radius: 10px;
  /* 动画：名称、时间、循环 */
  animation: loading 1s infinite;
}

/* 设置动画 */
@keyframes loading {
  0% {
    height: 0px;
  }

  50% {
    height: 50px;
  }

  100% {
    height: 0px;
  }
}

/* 为每一个竖条设置延时 */
.item:nth-child(2) {
  animation-delay: 0.1s;
}

.item:nth-child(3) {
  animation-delay: 0.2s;
}

.item:nth-child(4) {
  animation-delay: 0.3s;
}

.item:nth-child(5) {
  animation-delay: 0.4s;
}

.item:nth-child(6) {
  animation-delay: 0.5s;
}

.item:nth-child(7) {
  animation-delay: 0.6s;
}

.item:nth-child(8) {
  animation-delay: 0.7s;
}
</style>
